import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';

class DeleteDailyNews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false
    };

    this.delete(props);
  }

  delete(props) {
    const { id } = props.match.params;

    DailyNewsService.delete(id)
      .then((res) => {
        this.setState({ isSuccess: true });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    let body = 'Processing...';
    if (this.state && this.state.isSuccess) {
      body = 'SUCCESS';
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page'>
        {body}
      </section>
    );
  }
}

export default DeleteDailyNews;
